import React, { useEffect, useState } from 'react'
import TextInputFloat from '../../common/components/textInput/TextInputFloat';
import { Listbox } from '@headlessui/react'
import transactionService from '../../../api/services/transactionService';
import refreshIcon from "../../../assets/newIcons/rotate-right.png";

const bankTypeArr = [
    {
        "value": "abank",
        "name": "A Bank"
    },
    {
        "value": "ayabank",
        "name": "AYA Bank"
    },
    {
        "value": "ayapay",
        "name": "AYA Pay"
    },
    {
        "value": "cbbank",
        "name": "CB Bank"
    },
    {
        "value": "cbpay",
        "name": "CB Pay"
    },
    {
        "value": "kbzbank",
        "name": "KBZ Bank"
    },
    {
        "value": "kpay",
        "name": "K Pay"
    },
    {
        "value": "mabbank",
        "name": "MAB Bank"
    },
    {
        "value": "ok",
        "name": "OK$"
    },
    {
        "value": "uabbank",
        "name": "UAB Bank"
    },
    {
        "value": "wavepay",
        "name": "Wave Pay"
    },
    {
        "value": "yomabank",
        "name": "Yoma Bank"
    }
]

const Withdrawal = (props) => {
    const { t, accountList, fetchAccountList, userDetails, setIsLoading, setIsModalOpen,setMessage,handleSongClick,balance } = props;
    const [accountNo, setAccountNo] = useState('');
    const [accountName, setAccountName] = useState('');
    const [amount, setAmount] = useState('');
    const [remark, setRemark] = useState('');
    const [errorText, setErrorText] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [refresh,setRefresh] = useState(false); 

    const handleSubmit = async (e) => {
        handleSongClick();
        e.preventDefault();
        if (selectedOption === null) {
            setErrorText("Please select account type !!");
            return;
        }
        if(balance < amount){
            console.log("user details in withdrawal>>", balance)
            setErrorText("Amount is over than current amount !!");
            return;
        }

        //console.log("payload", payload);

        try {
            setErrorText(null);
            setIsLoading(true);

           const response = await transactionService.createWithdrawal({
                userName : userDetails.username,
                userId: Number(userDetails.userId),
                bankType: selectedOption.value,
                remark: remark,
                amount: Number(amount),
                accountName: accountName,
                isAdmin: false,
                accountNo: accountNo
            });

            setIsModalOpen(true);
            //setIsSuccess(true);
            if (response.message) {
                setMessage(t('transactionPending'));
            }
            else {
                setMessage(t('processSuccessful'));
            }
            setIsLoading(false);
            setAccountNo('');
            setAccountName('');
            setAmount('');
            setRemark('');
            setSelectedOption(null);
            setIsModalOpen(true);
          
        } catch (error) {
            console.log("res>>",error);
            //setIsSuccess(false);
            setIsLoading(false);
            setMessage(t('sendingFail'));
            setIsModalOpen(true);
            console.error('API request error:', error);
        }
    };

    useEffect(() => {
        if(refresh) fetchAccountList();
    },[refresh])

    return (
        <div className="z-50 flex flex-col mt-5 mx-4 sm:mx-0 h-[65vh] bg-white/[0.2] dark:backdrop-blur-sm backdrop-blur-sm dark:bg-primary/[0.2] dark:bg-opacity-30 bg-opacity-30 rounded-md shadow border border-white border-opacity-20">
            {/* <div className='pt-2'>
                <h6 className='text-center text-red-600'>{t('warningWithdrawal')}</h6>
            </div> */}
            <form
                onSubmit={handleSubmit}
                className="flex flex-col justify-center items-center h-full rounded-b-md shadow-md px-6 md:px-16 space-y-3"
            >
                <p className="font-bold">{t('withdraw')}</p>
                

                <SelectBox t={t} accountList={accountList} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
                <TextInputFloat
                    id={'accountNo'}
                    value={accountNo}
                    type="number"
                    setValue={setAccountNo}
                    placeholder={''}
                    label={t('accountNo')}
                />
                <TextInputFloat
                    id={'accountName'}
                    placeholder={''}
                    label={t('accountName')}
                    value={accountName}
                    type="text"
                    setValue={setAccountName}
                />
                <TextInputFloat
                    id={'amount'}
                    placeholder={''}
                    label={t('amount')}
                    value={amount}
                    type="number"
                    setValue={setAmount}
                />
                {/* <TextInputFloat
                    id={'remark'}
                    placeholder={''}
                    label={'Remark'}
                    value={remark}
                    type="text"
                    required={false}
                    setValue={setRemark}
                /> */}
                <div className='flex w-full justify-start items-center text-xs text-gray-500 dark:text-white'>
                    <img src={refreshIcon} alt='scan'
                        className={`w-3 mr-2 ${refresh ? "animate-spin" : ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setRefresh(true);
                            setTimeout(() => setRefresh(false), 1500);
                        }}
                    />
                    <span className='text-xs text-textColorGold'>{t('balance')} : {balance.toLocaleString()} {t('ks')}</span>
                </div>
                {errorText && <span className='text-xs text-red-600'>{errorText}</span>}
                <div className="flex w-full mt-5 text-center justify-center">
                    <button
                        className="py-2 px-8 w-full mt-4 bg-bodyText rounded-md shadow border border-bodyText border-opacity-25"
                        type="submit"
                    >
                        <span className='text-white'>{t('send')}</span>
                    </button>
                </div>

            </form>
        </div>
    )
}

export default Withdrawal;

const SelectBox = ({ t,accountList,selectedOption, setSelectedOption }) => {
    const handleSelectChange = (option) => {
        setSelectedOption(option);
    };

    return (
        <div className="w-full mx-auto mt-6 shadow-lg">
            <Listbox value={selectedOption} onChange={handleSelectChange}>
                <div className="relative">
                    <Listbox.Button className="w-full px-4 py-2 text-left bg-white dark:bg-transparent border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-focusColor">
                        {selectedOption ? (
                            <div className="flex items-center">
                                <img
                                    src={`/logo/${selectedOption.value}.png`}
                                    alt={selectedOption.value}
                                    className="dark:bg-slate-200"
                                    width={30}
                                    style={{ objectFit: 'contain', marginRight: '8px' }}
                                />
                                <span className='text-xs dark:text-white'>{selectedOption.name}</span>
                            </div>
                        ) : (
                            <span className="text-gray-500 text-sm">{t('selectAccountType')}</span>
                        )}
                    </Listbox.Button>
                    <Listbox.Options className="absolute w-full mt-1 bg-white z-50 border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto focus:outline-none">
                        {bankTypeArr.filter(a =>accountList.some(b => b.bankType === a.value)).map((account, idx) => (
                            <Listbox.Option key={idx} value={account}>
                                {({ active, selected }) => (
                                    <li key={account.value}
                                        className={`${active ? 'bg-focusColor text-white' : 'text-gray-900'
                                            } cursor-pointer select-none relative py-2 pl-10 pr-4 rounded-md transition-all duration-200`}
                                    >
                                        <div className="flex items-center">
                                            <img
                                                src={`/logo/${account.value}.png`} // Assuming the logos are in public/logo/
                                                alt={account.value}
                                                width={30}
                                                style={{ objectFit: 'contain', marginRight: '8px' }}
                                            />
                                            <span className={`${selected ? 'font-semibold' : ''
                                                } block truncate text-xs`}>{account.name}</span>
                                        </div>
                                        {selected && (
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600">
                                                {/* Checkmark Icon */}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                    className="w-5 h-5"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M16.704 4.704a1 1 0 10-1.408-1.408L8 11.586 4.704 8.29a1 1 0 10-1.408 1.408l4.5 4.5a1 1 0 001.408 0l7-7z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </span>
                                        )}
                                    </li>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </div>
            </Listbox>
        </div>
    )
};
